import StatusPill from '../../../common/components/status-pill/status-pill';

import '../styles/capability-card.css';

const RESULT_LABEL = {
    CANCELLED: 'Cancelado',
    TIMEOUT: 'Tiempo agotado',
    UNAVAILABLE: 'No disponible',
    PERMISSION_DENIED: 'Permiso denegado',
};

function ActionResult({ action, successText }) {
    if (action.status === 'idle') return null;
    if (action.isPending) return <p className="capability-card__result" role="status">Esperando respuesta del dispositivo…</p>;
    if (action.result?.ok) {
        return <p className="capability-card__result capability-card__result--ok" role="status">{successText}</p>;
    }
    const { code, message } = action.result.error;
    return (
        <p className="capability-card__result capability-card__result--error" role="status">
            <strong>{RESULT_LABEL[code] ?? 'Error'}:</strong> {message} <code className="capability-card__code">{code}</code>
        </p>
    );
}

export default function CapabilityCard({ icon, title, description, isAvailable, availabilityText, action, successText, children }) {
    return (
        <li className={`capability-card${isAvailable ? '' : ' capability-card--unavailable'}`}>
            <div className="capability-card__head">
                <span className="capability-card__icon">{icon}</span>
                <h3 className="capability-card__title">{title}</h3>
                <StatusPill tone={isAvailable ? 'ok' : 'idle'}>{availabilityText ?? (isAvailable ? 'Disponible' : 'No disponible')}</StatusPill>
            </div>
            <p className="capability-card__description">{description}</p>
            <div className="capability-card__actions">{children}</div>
            {action && <ActionResult action={action} successText={successText} />}
        </li>
    );
}
